module.exports = __webpack_public_path__ + "img/nav1h.24056069.png";